export const CUSTOM_DATA_TYPE_ICONS = {
  STRING: "fi fi-rr-text",
  URL: "fi fi-rr-link",
  INTEGER: "fi fi-rr-hastag",
  DOUBLE: "fi fi-rr-calculator",
  CURRENCY: "fi fi-rr-money",
  BOOLEAN: "fi fi-rr-check-circle",
  DATE: "fi fi-rr-calendar",
  DATETIME: "fi fi-rr-calendar-clock",
  TIME: "fi fi-rr-clock",
  PERIOD: "fi fi-rr-calendar-clock",
  STRING_ARRAY: "fi fi-rr-list-check",
  ENUM: "fi fi-rr-angle-small-down",
  COMBOLIST: "fi fi-rr-list",
};

